import React, { useEffect, useState } from 'react';
import {
    ButtonPrimary,
    ButtonFixedFooterLayout,
    skinVars,
    Text3,
    RadioGroup,
    BoxedRow,
    BoxedAccordion,
    BoxedAccordionItem,
    IbanField,
} from '@telefonica/mistica';
import { t } from 'i18next';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import { getCustomerAccounts } from '../../../../services/CustomerService';
import { CustomerAccount } from '../../../../models/Customer';
import { useChangeOwnershipContext } from '../../../../context/change-ownership-context/ChangeOwnershipContext';
import HeaderComponent from '../../../../components/HeaderComponent';

export const CustomerAccounts: React.FC = () => {
    const [customerAccounts, setCustomerAccounts] = useState<CustomerAccount[]>([]);
    const [customerAccountSelected, setCustomerAccountSelected] = useState('');
    const [valueIban, setValueIban] = useState('');
    const { setIbanInterested } = useChangeOwnershipContext();
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            await fetchCustomerAccounts();
        })();
    }, []);

    const fetchCustomerAccounts = async () => {
        try {
            const response = await getCustomerAccounts();
            setCustomerAccounts(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleChangeValue = (value: string) => setValueIban(value);

    const handleAccountChange = (id: string) => {
        setCustomerAccountSelected(id);
        setValueIban('');
    };

    const handleIbanFocus = () => {
        if (customerAccountSelected) {
            setCustomerAccountSelected('');
        }
    };

    const selectedAccountIban =
        customerAccountSelected && customerAccounts.find((account) => account.id === customerAccountSelected)?.iban;

    const iban = selectedAccountIban || valueIban;

    const handleButtonContinue = () => {
        setIbanInterested(iban);
        navigate('/change-ownership/contact-media');
    };

    const navigationBackHandler = () => navigate('/profile/personal-data');

    return (
        <div className='customer-accounts-page'>
            <HeaderComponent
                title={t('selectBankAccountTitle')}
                navigationBarOnBack={navigationBackHandler}
                breadcrumbs={[
                    { title: t('profileTitle'), url: '/profile' },
                    { title: t('personalDataTitle2'), url: '/profile/personal-data' },
                ]}
            />

            <div className='customer-accounts-page__content'>
                <ButtonFixedFooterLayout
                    button={
                        <ButtonPrimary disabled={!customerAccountSelected && !valueIban} onPress={handleButtonContinue}>
                            {t('next')}
                        </ButtonPrimary>
                    }
                >
                    <div className='customer-accounts-page__content-title'>
                        <Text3 regular color={skinVars.colors.textPrimary}>
                            {t('customerAccountsTitle1')}
                        </Text3>
                        <Text3 regular color={skinVars.colors.textPrimary}>
                            {customerAccounts?.length > 0
                                ? t('customerAccountsTitle2')
                                : t('customerAccountsTitle2NoAccounts')}
                        </Text3>
                    </div>
                    {customerAccounts?.length > 0 && (
                        <div className='customer-accounts-page__content-accounts'>
                            <RadioGroup
                                name='customer-account-selection'
                                value={customerAccountSelected}
                                onChange={handleAccountChange}
                            >
                                <div className='customer-accounts-page__content-accounts'>
                                    <RadioGroup
                                        name='customer-account-selection'
                                        value={customerAccountSelected}
                                        onChange={handleAccountChange}
                                    >
                                        <div className='customer-accounts-page__content-accounts-list'>
                                            {customerAccounts?.map((account) => (
                                                <BoxedRow
                                                    key={account.id}
                                                    title={t('customerAccountsRowTitle', {
                                                        accountNumber: account.number.substring(
                                                            account.number.length - 4,
                                                        ),
                                                    })}
                                                    radioValue={account.id}
                                                />
                                            ))}
                                        </div>
                                    </RadioGroup>
                                </div>
                            </RadioGroup>
                        </div>
                    )}
                    <div className='customer-accounts-page__content-addAccounts'>
                        <BoxedAccordion>
                            <BoxedAccordionItem
                                title={t('customerAccountsAccordionTitle')}
                                content={
                                    <div className='customer-accounts-page__content-addAccounts'>
                                        <div className='customer-accounts-page__content-addAccounts'>
                                            <IbanField
                                                name='bankAccount'
                                                label={t('profileChangeBankAccountLabel')}
                                                onFocus={handleIbanFocus}
                                                onChangeValue={handleChangeValue}
                                                value={valueIban}
                                                helperText={t('profileChangeBankAccountHelperText')}
                                            />
                                        </div>
                                    </div>
                                }
                            />
                        </BoxedAccordion>
                    </div>
                </ButtonFixedFooterLayout>
            </div>
        </div>
    );
};

export default CustomerAccounts;
